import { useLanguage } from '../../contexts/language';

import styles from './style.module.css';

// How complete a day is, as a word in a pill coloured like the week strip:
// green complete, yellow partial, white no entry.
export function CompletenessChip({ completeness }) {
  const { text } = useLanguage();

  return <span className={ `${ styles.chip } ${ styles[ completeness ] }` }>{ text.completeness[ completeness ] }</span>;
}
